/*
 * Purpose: Dashboard page — command center body inside AppShell
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { CommandCenterDashboard } from '@/components/dashboard/CommandCenterDashboard';
import { PageMotion } from '@/components/motion/PageMotion';

export default function Dashboard() {
  return (
    <PageMotion variant="body">
      <CommandCenterDashboard />
    </PageMotion>
  );
}
